// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2ccAI","footer":"ModalInfo_footer__5T4Dn"};